<template>
<div>

  <div class = "">

    <div class = "columns is-centered reviews-area section fix-white-margin-columns" style = "padding-bottom: 1rem;">
      <div class = "column is-10">
        <div class = "is-size-2-desktop is-size-3 has-text-black-ter title-font has-text-weight-bold">
          Opiniones de los clientes
        </div>
        <br>
        <div class = "is-desktop-half columns is-centered ">
          <div class = "column is-6">
            <p class = "is-size-5-desktop is-size-6 has-text-justified">
              Tu opinión es muy importante para nosotros, nos ayuda a corregir fallos y mejorar el servicio. Puedes opinar en nuestro Google Maps.
            </p>
            <br>
            <p class = "is-size-5-desktop is-size-6">
              Muchas gracias por tu confianza.
            </p>
          </div>
        </div>
        
      </div>
    </div>

    <div id = "map">

    </div>

    <div class = "columns is-centered is-multiline fix-white-margin-columns" ref="contact">
      <div class = "column is-one-third" v-for = "review in reviews" :key = "review.time">
        <div class = "card">
          <div class="card-content">
            <div class="media">
              <div class="media-left">
                <figure class="image is-64x64">
                  <img :src="review.profile_photo_url" alt="Placeholder image">
                </figure>
              </div>
              <div class="media-content">
                <p class="title is-4 has-text-weight-normal">{{review.author_name}}</p>
                <div class ="subtitle">
                  <span v-for="n in review.rating" :key = "n">
                    <font-awesome-icon class = "spacedicon star is-size-6" :icon = "['fas', 'star']"/>
                  </span>
                  <span class = "is-size-6 has-text-grey"> {{review.relative_time_description}} </span>
                </div>
              </div>
            </div>

            <div class="content word">
              {{review.text}}
              <br>
              <span class = "is-pulled-right"> <time :datetime="review.time" class = "has-text-grey"> {{convertDate(review.time)}} </time> </span>
              
            </div>
          </div>
        </div>
        
      </div>
    </div>
    <br>
  </div>


</div>
</template>

<script>

import {gmapApi} from 'vue2-google-maps'

export default {
  name: 'Reviews',
  data() {
    return { 
      reviews: [/*
        {
          author_name: "Mark",
          rating: 5,
          profile_photo_url: "https://via.placeholder.com/96/CCCCCC/808080/?text=Placeholder pic",
          relative_time_description: "hace un mes",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus nec iaculis mauris.",
          time: 1491144016
        },
        {
          author_name: "Mark",
          rating: 5,
          profile_photo_url: "https://via.placeholder.com/96/CCCCCC/808080/?text=Placeholder pic",
          relative_time_description: "hace un mes",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus nec iaculis mauris.",
          time: 1491144017
        },
        {
          author_name: "Mark",
          rating: 5,
          profile_photo_url: "https://via.placeholder.com/96/CCCCCC/808080/?text=Placeholder pic",
          relative_time_description: "hace un mes",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus nec iaculis maurisaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa.",
          time: 1491144018
        },
        {
          author_name: "Mark",
          rating: 5,
          profile_photo_url: "https://via.placeholder.com/96/CCCCCC/808080/?text=Placeholder pic",
          relative_time_description: "hace un mes",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus nec iaculis mauris.",
          time: 1491144019
        },
        {
          author_name: "Mark",
          rating: 5,
          profile_photo_url: "https://via.placeholder.com/96/CCCCCC/808080/?text=Placeholder pic",
          relative_time_description: "hace un mes",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus nec iaculis mauris.",
          time: 1491144020
        }*/
      ]
    }
  },
  methods: {
    convertDate: function(dateNumber){
      let date = new Date(1000*dateNumber);
      let formatted_date = date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
      return formatted_date
    },
    loadReviews: function(){

      //getting reviews using the map we already made for the map component, extracting google and using it like the places api
      var google = gmapApi();
      var service = new google.maps.places.PlacesService(document.getElementById('map'));
      service.getDetails({
        placeId: 'ChIJYcaKE78REg0R7I17pYnJVmc'
      }, (place) => {
        if(place.reviews){
          this.reviews = place.reviews;
        }
      });

    }
  },
  mounted(){
    setTimeout(this.loadReviews,1000) //Botchy fix to ensure the map is always loaded
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.star {
  color: #FBBC04;
}
.word{
  word-break: break-all;
}

h1, h2 {
  font-weight: normal;
}
div {
  text-align: center;
  font-family: 'Century Gothic', 'Tahoma', 'Verdana'
}

.reviews-area {
  background-color: #B4D9ED;
}

.fix-white-margin-columns {
  margin-right: 0px !important;
}


</style>

